import React from 'react';
import { colors, spacing } from '../../../design/tokens';
import { useAuth } from '../../../context/AuthContext';
import { UserRole } from '../../../types';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { HowItWorks } from '../components/HowItWorks';
import { Footer } from '../components/Footer';

export const HomePage: React.FC = () => {
  const { user } = useAuth();

  const getDashboardPath = () => {
    if (!user) return '/login';
    if (user.role === UserRole.SUPER_ADMIN) return '/super/dashboard';
    if (user.role === UserRole.ENTERPRISE_ADMIN) return '/enterprise/dashboard';
    if (user.role === UserRole.EMPLOYEE) return '/employee/dashboard';
    return '/user/balance';
  };

  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navigation user={user} getDashboardPath={getDashboardPath} />
      
      <main>
        <Hero user={user} getDashboardPath={getDashboardPath} />
        
        <Features />
        
        <HowItWorks />

        {/* ROI Stats Section */}
        <section style={{ padding: `${spacing.xxl} ${spacing.xl}`, backgroundColor: 'white', borderBottom: `1px solid ${colors.neutral[100]}` }}>
          <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: spacing.xxl, textAlign: 'center' }}>
            <div>
              <div style={{ fontSize: '48px', fontWeight: 800, color: colors.brand.main }}>70%</div>
              <p style={{ color: colors.neutral[600], fontWeight: 600 }}>Debugging Time Saved</p>
            </div>
            <div>
              <div style={{ fontSize: '48px', fontWeight: 800, color: colors.brand.main }}>100%</div>
              <p style={{ color: colors.neutral[600], fontWeight: 600 }}>Automated Fixes</p>
            </div>
            <div>
              <div style={{ fontSize: '48px', fontWeight: 800, color: colors.brand.main }}>0</div>
              <p style={{ color: colors.neutral[600], fontWeight: 600 }}>Security Overhead</p>
            </div>
            <div>
              <div style={{ fontSize: '48px', fontWeight: 800, color: colors.brand.main }}>24/7</div>
              <p style={{ color: colors.neutral[600], fontWeight: 600 }}>Continuous Scanning</p>
            </div>
          </div>
        </section>

        {/* ROI CTA */}
        <section style={{ 
          padding: `100px ${spacing.xl}`, 
          background: `linear-gradient(45deg, ${colors.neutral[1000]} 0%, ${colors.neutral[900]} 100%)`, 
          color: 'white', 
          textAlign: 'center' 
        }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{ fontSize: '48px', fontWeight: 800, marginBottom: spacing.lg, letterSpacing: '-1px' }}>Ready to Scale Your Engineering Output?</h2>
            <p style={{ fontSize: '20px', color: colors.neutral[400], marginBottom: spacing.xl, lineHeight: 1.6 }}>
              Don't let technical debt and security vulnerabilities slow down your roadmap. Let Exibrain handle the remediation.
            </p>
            <div style={{ display: 'flex', gap: spacing.md, justifyContent: 'center' }}>
              <a href="/signup" style={{ 
                padding: `${spacing.md} ${spacing.xxl}`, 
                backgroundColor: colors.brand.main, 
                color: 'white', 
                borderRadius: '8px', 
                textDecoration: 'none', 
                fontWeight: 800,
                fontSize: '18px'
              }}>Get Started Now</a>
              <a href="#features" style={{ 
                padding: `${spacing.md} ${spacing.xxl}`, 
                backgroundColor: 'white', 
                color: colors.neutral[1000], 
                borderRadius: '8px', 
                textDecoration: 'none', 
                fontWeight: 800,
                fontSize: '18px'
              }}>Explore Features</a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};
